<div *ngIf="form" [formGroup]="form" bindQueryParams>
    <div class="row">
        <mat-form-field>
            <buffered-input placeholder="Nome" formControlName="nome"></buffered-input>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Studio Associato</mat-label>
            <studio-picker formControlName="studio"></studio-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Compagnia</mat-label>
            <compagnia-picker formControlName="compagnia"></compagnia-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Stato automatizzato</mat-label>
            <stato-incarico-picker formControlName="stato_incarico"></stato-incarico-picker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Tipo template</mat-label>
            <tipo-template-picker formControlName="tipo_template"></tipo-template-picker>
        </mat-form-field>
    </div>

</div>